import React, { useState, useEffect } from 'react'
import { logoWhite } from '../../../assets'
import { useHistory } from 'react-router-dom'
import './style.css'
import {
    IconUserCircle,
    IconLogout2,
    IconClockHour4,
    IconClipboardCheck,
    IconBook,
    IconBuildingSkyscraper,
    IconUser
} from '@tabler/icons-react';
import { maleAvatar } from '../../../assets'
import useFetchUserByToken from '../../../hooks/useFetchUserByToken'
import { FormChangePassword } from '../../'
import Modal from 'react-bootstrap/Modal';

export default function Sidebar() {

    const user = useFetchUserByToken()

    const [currentUrl, setCurrentUrl] = useState('')
    const history = useHistory()
    const handleChangePage = (path) => {
        setCurrentUrl(path)
        if (path === '/login') {
            window.location.reload()
            localStorage.clear()
        } else {
            history.push(path)
        }
    }

    useEffect(() => {
        setCurrentUrl(window.location.pathname)
    }, [])

    const [showChangePassword, setshowChangePassword] = useState(false)

    const handleAfterSubmit = () => {
        setshowChangePassword(false)
        setTimeout(() => {
            window.location.reload()
            localStorage.clear()
        }, 3000);
    }

    // console.log(currentUrl)

    return (
        <>
            <aside className="navbar navbar-vertical navbar-expand-lg navbar-transparent"
                style={{ background: 'linear-gradient(#0C86D9, #26D07C)' }}
            >
                <div className="container-fluid">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <h1 className="navbar-brand navbar-brand-autodark">
                        <span>
                            <img src={logoWhite} width={110} height={32} alt="logoEli" className="navbar-brand-image" />
                        </span>
                    </h1>
                    <div className="navbar-nav flex-row d-lg-none">
                        <div className="nav-item d-none d-lg-flex me-3">
                            <div className="btn-list">
                                <span href="https://github.com/tabler/tabler" className="btn" target="_blank" rel="noreferrer">
                                    {/* Download SVG icon from http://tabler-icons.io/i/brand-github */}
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon" width={24} height={24} viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5" /></svg>
                                    Source code
                                </span>
                                <span href="https://github.com/sponsors/codecalm" className="btn" target="_blank" rel="noreferrer">
                                    {/* Download SVG icon from http://tabler-icons.io/i/heart */}
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon text-pink" width={24} height={24} viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M19.5 13.572l-7.5 7.428l-7.5 -7.428m0 0a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572" /></svg>
                                    Sponsor
                                </span>
                            </div>
                        </div>
                        <div className="d-none d-lg-flex">
                            <div className="nav-item dropdown d-none d-md-flex me-3">
                                <span className="nav-link px-0" data-bs-toggle="dropdown" tabIndex={-1} aria-label="Show notifications">
                                    {/* Download SVG icon from http://tabler-icons.io/i/bell */}
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon" width={24} height={24} viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" /><path d="M9 17v1a3 3 0 0 0 6 0v-1" /></svg>
                                    <span className="badge bg-red" />
                                </span>
                                <div className="dropdown-menu dropdown-menu-arrow dropdown-menu-end dropdown-menu-card">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Last updates</h3>
                                        </div>
                                        <div className="list-group list-group-flush list-group-hoverable">
                                            <div className="list-group-item">
                                                <div className="row align-items-center">
                                                    <div className="col-auto"><span className="status-dot status-dot-animated bg-red d-block" /></div>
                                                    <div className="col text-truncate">
                                                        <span className="text-body d-block">Example 1</span>
                                                        <div className="d-block text-muted text-truncate mt-n1">
                                                            Change deprecated html tags to text decoration classes (#29604)
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <span className="list-group-item-actions">
                                                            {/* Download SVG icon from http://tabler-icons.io/i/star */}
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon text-muted" width={24} height={24} viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" /></svg>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="list-group-item">
                                                <div className="row align-items-center">
                                                    <div className="col-auto"><span className="status-dot d-block" /></div>
                                                    <div className="col text-truncate">
                                                        <span className="text-body d-block">Example 2</span>
                                                        <div className="d-block text-muted text-truncate mt-n1">
                                                            justify-content:between ⇒ justify-content:space-between (#29734)
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <span className="list-group-item-actions show">
                                                            {/* Download SVG icon from http://tabler-icons.io/i/star */}
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon text-yellow" width={24} height={24} viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" /></svg>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="list-group-item">
                                                <div className="row align-items-center">
                                                    <div className="col-auto"><span className="status-dot d-block" /></div>
                                                    <div className="col text-truncate">
                                                        <span className="text-body d-block">Example 3</span>
                                                        <div className="d-block text-muted text-truncate mt-n1">
                                                            Update change-version.js (#29736)
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <span className="list-group-item-actions">
                                                            {/* Download SVG icon from http://tabler-icons.io/i/star */}
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon text-muted" width={24} height={24} viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" /></svg>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="list-group-item">
                                                <div className="row align-items-center">
                                                    <div className="col-auto"><span className="status-dot status-dot-animated bg-green d-block" /></div>
                                                    <div className="col text-truncate">
                                                        <span className="text-body d-block">Example 4</span>
                                                        <div className="d-block text-muted text-truncate mt-n1">
                                                            Regenerate package-lock.json (#29730)
                                                        </div>
                                                    </div>
                                                    <div className="col-auto">
                                                        <span className="list-group-item-actions">
                                                            {/* Download SVG icon from http://tabler-icons.io/i/star */}
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon text-muted" width={24} height={24} viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" /></svg>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="nav-item dropdown">
                            <span type="button" className="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown" aria-label="Open user menu">
                                <img className="avatar avatar-sm" src={maleAvatar} alt='maleAvatar' />
                                <div className="d-none d-xl-block ps-2">
                                    <div>{user.user.firstName} {user.user.lastName}</div>
                                    <div className="mt-1 small text-muted">{user.user.email}</div>
                                </div>
                            </span>
                            <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                                <span className="dropdown-item" onClick={() => setshowChangePassword(true)}>Change Password</span>
                            </div>
                        </div>
                    </div>
                    <div className="collapse navbar-collapse" id="navbar-menu">
                        <ul className="navbar-nav pt-lg-3" type="button">
                            <li className="nav-item mb-3"
                                onClick={() => handleChangePage('/')}
                                style={{ backgroundColor: currentUrl === '/' ? '#26D07C' : '' }}
                            >
                                <span className="nav-link" style={{ color: '#FFFFFF', fontWeight: '400' }}>
                                    <IconUserCircle
                                        width={28}
                                        height={28}
                                    />
                                    &nbsp;
                                    {user.user.firstName} {user.user.lastName}
                                </span>
                            </li>
                            {
                                user.user.Account !== undefined ?
                                    user.user.Account.type === "individual" ?
                                        <li className="nav-item"
                                            onClick={() => handleChangePage('/profile-individu')}
                                            style={{ backgroundColor: currentUrl === '/profile-individu' ? '#26D07C' : '' }}
                                        >
                                            <span className="nav-link" style={{ color: '#FFFFFF', fontWeight: '500' }}>
                                                <IconUser
                                                    width={28}
                                                    height={28}
                                                />
                                                &nbsp;
                                                Profil Individu
                                            </span>
                                        </li>
                                        :
                                        <li className="nav-item"
                                            onClick={() => handleChangePage('/profile-corporate')}
                                            style={{ backgroundColor: currentUrl === '/profile-corporate' ? '#26D07C' : '' }}
                                        >
                                            <span className="nav-link" style={{ color: '#FFFFFF', fontWeight: '500' }}>
                                                <IconBuildingSkyscraper
                                                    width={28}
                                                    height={28}
                                                />
                                                &nbsp;
                                                Profil Perusahaan
                                            </span>
                                        </li>
                                    :
                                    ''

                            }
                            <li className="nav-item"
                                onClick={() => handleChangePage('/katalog-program')}
                                style={{ backgroundColor: currentUrl === '/katalog-program' ? '#26D07C' : '' }}
                            >
                                <span className="nav-link" style={{ color: '#FFFFFF', fontWeight: '500' }}>
                                    <IconBook
                                        width={28}
                                        height={28}
                                    />
                                    &nbsp;
                                    Katalog Program
                                </span>
                            </li>
                            <li className="nav-item"
                                onClick={() => handleChangePage('/program-terdaftar')}
                                style={{ backgroundColor: currentUrl === '/program-terdaftar' ? '#26D07C' : '' }}
                            >
                                <span className="nav-link" style={{ color: '#FFFFFF', fontWeight: '500' }}>
                                    <IconClipboardCheck
                                        width={28}
                                        height={28}
                                    />
                                    &nbsp;
                                    Program Terdaftar
                                </span>
                            </li>
                            <li className="nav-item"
                                onClick={() => handleChangePage('/riwayat-transaksi')}
                                style={{ backgroundColor: currentUrl === '/riwayat-transaksi' ? '#26D07C' : '' }}
                            >
                                <span className="nav-link" style={{ color: '#FFFFFF', fontWeight: '500' }}>
                                    <IconClockHour4
                                        width={28}
                                        height={28}
                                    />
                                    &nbsp;
                                    Riwayat Transaksi
                                </span>
                            </li>
                            <li className="nav-item"
                                onClick={() => handleChangePage('/login')}
                            >
                                <span className="nav-link" style={{ color: '#FFFFFF', fontWeight: '500' }}>
                                    <IconLogout2
                                        width={28}
                                        height={28}
                                    />
                                    &nbsp;
                                    Keluar
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </aside>

            <Modal
                show={showChangePassword}
                size='sm'
                onHide={() => setshowChangePassword(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header
                    closeButton
                    style={{ backgroundColor: '#F2F2F2' }}

                >
                    <Modal.Title>
                        <h3 className='mb-3'>Form Ubah Password</h3>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body
                    style={{ backgroundColor: '#F2F2F2' }}

                >
                    <FormChangePassword
                        close={() => handleAfterSubmit()}
                        userId={user?.user?.id}
                    />
                </Modal.Body>
            </Modal>

        </>
    )
}
